<div class="profile-wrap">
  <div class="header">
    <span>profile</span>
    <i class="fi-x" (click)="handleCloseChatProfile()"></i>
  </div>
  <div class="content-wrap">
    <div class="user-info">
      <div class="bg">
        <img [src]="avatarUrl" />
        <div class="username-wrap">
          <div class="name">{{ sender.nickname }}</div>

          <div *ngIf="role === UserRole.Moderator" class="tag-wrap">
            <span>Moderator</span>
          </div>
          <div *ngIf="role === UserRole.User" class="btn-wrap">
            <cs-button
              *ngIf="!isSelfUser"
              (buttonClick)="handleClickBlockUser()"
              [iconLeft]="isBlock ? 'fi-volume-up' : 'fi-volume-off-filled'"
              [iconType]="'icon'"
              [color]="'third'"
              [size]="'small'"
              [width]="'30px'"
              [height]="'30px'"
            />
            <!-- 第二階段開放 -->
            <!-- <cs-button
              (buttonClick)="handleClickTip()"
              [color]="'accent'"
              [height]="'30px'"
              [width]="'115px'"
              [size]="'small'"
              [label]="'Send a tip'"
            /> -->
          </div>
        </div>
      </div>
    </div>
    <div class="loading" [appLoading]="!isLoaded">
      <ng-container *ngIf="isLoaded && role === UserRole.User">
        <div class="container first">
          <div class="title">
            <span>{{ 'About ' + sender.nickname }}</span>
          </div>
          <ng-container *ngIf="!hiddenMode && !loading; else hiddenTemplate">
            <div class="content">
              <div class="block first">
                <img class="cube" src="assets/images/profile/since.png" alt="" />
                <span class="sub-title text">In the pub since</span>
                <span class="date">{{ profileData?.registerDate || '' | mdate: 'DD/MM/YYYY' }}</span>
              </div>
              <div class="block">
                <img class="cube" src="assets/images/profile/highest-multiplier.png" alt="" />
                <span class="sub-title text">Highest Multiplier</span>
                <span class="data">{{ 'x' + (profileData?.highestMultipler || 0) }}</span>
                <!-- 第二階段開放 -->
                <!-- <div class="see-bet">
                <cs-button
                  [color]="'secondary'"
                  [size]="'small'"
                  [height]="'30px'"
                  [label]="'See bet'"
                  (buttonClick)="handleClickHighestBet()"
                />
              </div> -->
              </div>
            </div>
          </ng-container>
        </div>
        <div class="container">
          <div class="title">
            <span>Basic stats</span>
          </div>
          <ng-container *ngIf="!hiddenMode && !loading; else hiddenTemplate">
            <div class="content">
              <div class="block first">
                <span class="sub-title">Bets</span>
                <div class="detail first">
                  <div class="item">Wins</div>
                  <div class="number">{{ profileData?.totalWins || 0 }}</div>
                </div>
                <div class="detail">
                  <div class="item">Wagered</div>
                  <div>
                    <span class="number">
                      <cs-currency-converter
                        [amount]="profileData?.totalWagered || 0"
                        [currency]="'USDT'"
                        [isConvertToSystemSettingCurrency]="true"
                      />
                      <cs-currency-unit-display [currency]="currentCurrency" [iconSize]="18" />
                    </span>
                  </div>
                </div>
              </div>
              <div class="block coming-soon">
                <span class="sub-title">Chat activity</span>
                <div class="detail first">
                  <div class="item">Tips sent</div>
                  <div class="number">{{ profileData?.tipsSent || 0 }}</div>
                </div>
                <div class="detail">
                  <div class="item">Tips received</div>
                  <div class="number">{{ profileData?.tipsReceived || 0 }}</div>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </ng-container>
      <ng-container *ngIf="isLoaded && role === UserRole.Moderator">
        <div class="moderator-data">
          <i class="fi-exclamation-circle-filled"></i>
          <span>No details to show for this account.</span>
        </div>
      </ng-container>
    </div>
  </div>
</div>

<ng-template #hiddenTemplate>
  <div class="content hidden-mode">
    <i class="fi-incognito-filled"></i>
    <span>Details for this profile are not visible</span>
  </div>
</ng-template>
